import r from"color";const o=o=>{const t=r(o),[c,n,a]=t.rgb().array();return c+","+n+","+a};export{o as colorToRgb};